import * as types from './constants';

import { request, requestConfig } from './../../../utils/request';
import { PATHS } from './../../../utils/paths';

const getNewsStoriesStart = () => ({
    type: types.GET_NEWS_STORIES_START
});

const getNewsStoriesSuccess = (data) => ({
    type: types.GET_NEWS_STORIES_SUCCESS,
    data
});

const getNewsStoriesFailure = (error) => ({
    type: types.GET_NEWS_STORIES_FAILURE,
    error
});

export const getNewsStories = () => (dispatch, getStore) => {
    dispatch(getNewsStoriesStart());

    return request(PATHS.news.getNewsStories(), requestConfig('GET', null, getStore().auth.token))
        .then((response) => {
            //console.log('get dashboard success', response);
            response.data.forEach((story) => {
                story.label = story.title;
                story.value = story.postPageUrl;
            });
            dispatch(getNewsStoriesSuccess(response.data));
            return response;
        })
        .catch((error) => {
            //console.log('get dashboard error', error);
            dispatch(getNewsStoriesFailure(error));
            return error;
        });
};



// WEBPACK FOOTER //
// ./src/containers/News/store/actions.js